export default "__VITE_ASSET__BgvIm3bx__"